export default __webpack_public_path__ + "static/media/ToroOpen.ad08b275.jpg";